<template>
<div style="height:100%;overflow-y:auto;">
<v-toolbar dark class="primary">
    <v-btn @click.native="$router.go(-1)" icon>
        <v-icon>chevron_left</v-icon>
    </v-btn>        
    <v-toolbar-title>Templates</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-btn icon>
        <v-icon>search</v-icon>
    </v-btn>
    <v-btn icon>
        <v-icon>more_vert</v-icon>
    </v-btn>
</v-toolbar>  

<v-container>
<v-row wrap>
    <!-- ***************** Left Column ******************* -->
    <v-col xs12 sm4>

    </v-col>

    <!-- ***************** Right Column ******************* -->
    <v-col xs12 sm8>
        <div class="pa-3">
            <v-select v-model="program" :items="programItems" />
            <template v-if="this.program == 'cno'">
                <v-text-field v-model="newOfficeNumber" label="Create office number (eg. 001)" />
                <v-text-field v-model="newOfficeName" label="Office Name" />
                <v-text-field v-model="newOfficePin" label="Pin (4 digit)" />
            </template>
            <v-text-field v-if="singleItem" v-model="itemKey" label="Source Item Key" />
            <v-text-field disabled v-if="singleItem" :value="transactionKey" label="Transaction Key" />
            <UserChooser v-if="this.program == 'tcu' || this.program == 'ttu'" v-model="user" label="User" />
            <v-select v-model="sourceTenant" :items="tenants" item-text="name" item-value="meta.key" label="Source Tenant" />
            <v-combobox v-model="destinationTenant" :items="tenantList.filter(o => o.meta.key != sourceTenant)" multiple chips item-text="name" item-value="meta.key" label="Destination Tenant" />
            <a href="" @click.prevent="destinationTenant = tenantList.filter(o => parseInt(o.meta.key) < 900 && o.meta.key != sourceTenant)">All Mortgage Tenants</a>
            <div style="display:flex">
                <v-switch v-model="move" color="primary" label="Remove from Source" />
                <v-checkbox v-model="simulateWrites" color="primary" label="Simulate Writes" />
                <v-checkbox v-model="simulateDeletes" color="primary" label="Simulate Deletes" />
            </div>
            <v-btn @click="run">Go</v-btn>
            <v-textarea v-model="output" label="Results" />
        </div>        

    </v-col> 
    <!-- End right column -->
</v-row>
</v-container>  

</div>
</template>

<script>
 
import DialogBox from '../ui-elements/DialogBox'
import UserChooser from '../ui-elements/UserChooser'
import DataHelpers from '../helpers/DataHelpers'
import ContactHelpers from '../helpers/ContactHelpers';
import FirebaseHelpers from '../helpers/FirebaseHelpers';
import Utilities from '../helpers/Utilities';
import NiceData from '../data/NiceData'

export default {
    data() {
        return {
            tenantList: [],
            program: null,
            itemKey: null,
            newOfficeNumber: null,
            newOfficeName: null,
            newOfficePin: null,
            output: '',
            user: null,
            sourceTenant: null,
            destinationTenant: null,
            simulateWrites: true,
            simulateDeletes: true,
            move: false,
        }
    },
    components: {
        DialogBox,
        UserChooser,
    },

    props: {
        item: String,
        action: String,
        transactionKey: String
    },

    computed: {

        singleItem() {
            return (
                this.program == 'tc' ||
                this.program == 'tot' ||
                this.program == 'ttg' ||
                this.program == 'te' ||
                this.program == 'tme' ||
                false
            )
        },

        programItems() {
            return [
                {text: "Transfer Contact", value: 'tc'},
                {text: "Transfer Contacts for User", value: 'tcu'},
                {text: "Transfer All Contacts", value: 'tac'},
                {text: "Transfer Tasks for User", value: 'ttu'},
                {text: "Transfer All Templates", value: 'tat'},
                {text: "Transfer One Template", value: 'tot'},
                {text: "Transfer Template to Global", value: 'ttg'},
                {text: "Transfer Lookups", value: 'tl'},
                {text: "Transfer All Groups", value: 'tag'},
                {text: "Transfer Element", value: 'te'},
                {text: "Delete Element", value: 'de'},
                {text: "Transfer Multiple Elements", value: 'tme'},
                {text: "Create an Office", value: 'cno'},
            ]
        },
        tenants() {
            return this.$store.getters.officesActive
        },
        sourceTenantRef() {
            return DataHelpers.getRootRef().child('tenants').child(this.sourceTenant)
        },

        destinationTenantRef() {
            return DataHelpers.getRootRef().child('tenants').child(this.destinationTenant)
        }        


    },


    methods: {
        initialiseDialog() {
            this.program = this.action
            this.itemKey = this.item
            this.sourceTenant = this.$store.getters.tenantKey
            this.output = ''
            DataHelpers.fetchUser().then(user => {
                const officesRef = DataHelpers.getUserRef().child('offices')
                NiceData.fetchItemsFromFirebase(officesRef).then(offices => {
                    this.tenantList = offices
                })
            }) 

        },
        log(msg) {
            this.output += msg + '\n'
        },
        run() {
            this.output = ''
            if(this.program == 'tc')
                this.transferContact()
            if(this.program == 'tat')
                this.transferAllTemplates()
            if(this.program == 'tcu')
                this.transferContactsForUser()
            if(this.program == 'tac')
                this.transferAllContacts()
            if(this.program == 'ttu')
                this.transferTasksForUser()
            if(this.program == 'tl')
                this.transferLookups()
            if(this.program == 'tag')
                this.transferAllGroups()
            if(this.program == 'tot')
                this.transferOneTemplate()
            if(this.program == 'ttg')
                this.transferTemplateToGlobal()
            if(this.program == 'te')
                this.transferElement()
            if(this.program == 'de')
                this.deleteElement()
            if(this.program == 'tme')
                this.transferElement()
            if(this.program == 'cno')
                this.createNewOffice()

        },

        transferElement() {
            let itemArr = this.itemKey.split(',')
            this.destinationTenant.forEach(destinationTenant => {

                itemArr.forEach(itemKey => {
    
                    let sourceTemplateRef = this.sourceTenantRef.child('transactions').child(this.transactionKey).child('elements').child(itemKey)
                    let destTemplateRef = DataHelpers.getRootRef().child('tenants').child(destinationTenant.meta.key).child('transactions').child(this.transactionKey).child('elements')
                    
                    this.copyFirebaseData(sourceTemplateRef, destTemplateRef, this.move, true).then(result => {
                        this.log('Transferred element from ' + sourceTemplateRef.toString() + ' to ' + destTemplateRef.toString())
                    })
                })
            })
        },

        deleteElement() {
            let itemArr = this.itemKey.split(',')
            //remove all the destinations...
            this.destinationTenant.forEach(destinationTenant => {
                itemArr.forEach(itemKey => {
                    let ref = DataHelpers.getRootRef().child('tenants').child(destinationTenant.meta.key).child('transactions').child(this.transactionKey).child('elements').child(itemKey)
                    ref.remove()
                    this.log('Removed element from ' + destinationTenant.meta.key)
                })
            })
            //remove the original...
            
            itemArr.forEach(itemKey => {
               this.sourceTenantRef.child('transactions').child(this.transactionKey).child('elements').child(itemKey).remove()
                this.log('Removed element from source')
            })


        },

        transferContact() {
            let newTenant = this.destinationTenant[0].meta.key
            this.log(`Moving to tenant ${newTenant} ...`)
            this.copyContactToTenant(this.itemKey, newTenant)
            NiceData.fetchItemSingle(this.sourceTenantRef.child('contacts').child(this.itemKey)).then(contact => {
                
                if(contact.partner)
                    this.copyContactToTenant(contact.partner.key, newTenant)
            })

        },

        transferOneTemplate() {
            
            this.destinationTenant.forEach(destinationTenant => {

                let sourceTemplateRef = this.sourceTenantRef.child('templates').child(this.itemKey)
                let destTemplateRef = DataHelpers.getRootRef().child('tenants').child(destinationTenant.meta.key).child('templates')
                
                this.copyFirebaseData(sourceTemplateRef, destTemplateRef, this.move, true).then(result => {
                    this.log('Transferred template to ' + destTemplateRef.toString())
                })
            })
        },  

        transferTemplateToGlobal() {
            let sourceTemplateRef = this.sourceTenantRef.child('templates').child(this.itemKey)
            let destTemplateRef = DataHelpers.getRootRef().child('app/templates')
            
            this.copyFirebaseData(sourceTemplateRef, destTemplateRef, this.move, true).then(result => {
                this.log('Transferred to global')
            })
        },        

        transferAllTemplates() {
                let sourceTemplateRef = this.sourceTenantRef.child('templates')
                let destTemplateRef = DataHelpers.getRootRef().child('tenants').child(this.destinationTenant[0].meta.key)
                
                this.copyFirebaseData(sourceTemplateRef, destTemplateRef, this.move, true).then(result => {
                    this.log('Transferred ' + Object.keys(result.object).length.toString() + ' templates ')
                })

                sourceTemplateRef = this.sourceTenantRef.child('transactionTemplates')
                destTemplateRef = DataHelpers.getRootRef().child('tenants').child(this.destinationTenant[0].meta.key)
                
                this.copyFirebaseData(sourceTemplateRef, destTemplateRef, this.move, true).then(result2 => {
                    
                    this.log('Transferred ' + Object.keys(result2.object).length.toString() + ' Transaction templates ')
                })
            
        },

        transferLookups() {
                let sourceTemplateRef = this.sourceTenantRef.child('lookup')
                let destTemplateRef = DataHelpers.getRootRef().child('tenants').child(this.destinationTenant[0].meta.key)
                
                this.copyFirebaseData(sourceTemplateRef, destTemplateRef, this.move, true).then(result => {
                    this.log('Transferred ' + Object.keys(result.object).length.toString() + ' lookup items')
                })
        },

        transferAllGroups() {
                let sourceTemplateRef = this.sourceTenantRef.child('groups')
                let destTemplateRef = DataHelpers.getRootRef().child('tenants').child(this.destinationTenant[0].meta.key)
                
                this.copyFirebaseData(sourceTemplateRef, destTemplateRef, this.move, true).then(result => {
                    this.log('Transferred ' + Object.keys(result.object).length.toString() + ' groups')
                })
        },

        transferContactsForUser() {
            let listContactsRef = this.sourceTenantRef.child('contacts').orderByChild('owner/key').equalTo(this.user.key)
            console.log('ref is ' + listContactsRef.toString())
            listContactsRef.once('value', snap => {
                snap.forEach(itemSnap => {
                    let contactKey = itemSnap.key
                    let contact = itemSnap.val()
                    this.log('Transferring contact: ' + ContactHelpers.fullName(contact) + ' - ' + contactKey)
                    this.copyContactToTenant(contactKey, this.destinationTenant[0].meta.key)
                })
            })
        },

        transferAllContacts() {
            let sourceRef = this.sourceTenantRef.child('contacts')
            console.log('ref is ' + sourceRef.toString())
            sourceRef.once('value', snap => {
                snap.forEach(itemSnap => {
                    let contactKey = itemSnap.key
                    let contact = itemSnap.val()
                    this.log('Transferring contact: ' + ContactHelpers.fullName(contact) + ' - ' + contactKey)
                    this.copyContactToTenant(contactKey, this.destinationTenant[0].meta.key)
                })
            })
        },
 
        transferTasksForUser() {
            let sourceRef = this.sourceTenantRef.child('tasks')
            let listTasksRef = sourceRef.orderByChild('assigned/uid').equalTo(this.user.key)
            let destRef = this.destinationTenantRef.child('tasks')
            console.log('ref is ' + listTasksRef.toString())
    
            listTasksRef.once('value', snap => {
                console.log(snap.val())
                snap.forEach(itemSnap => {
                
                    let taskKey = itemSnap.key
                    let task = itemSnap.val()
                    this.log('Transferring task: ' + task.title + ' - ' + taskKey)
                    this.copyFirebaseData(sourceRef.child(taskKey), destRef, this.move, true ).then(result => {
                        this.log('Done...')
                    })
                })
            })
        },

        copyContactToTenant(contactKey, tenant) {
            let sourceContactRef = this.sourceTenantRef.child('contacts').child(contactKey)
            let destContactRef = DataHelpers.getRootRef().child('tenants').child(tenant).child('contacts')
            
            this.copyFirebaseData(sourceContactRef, destContactRef, this.move, true).then(result => {
                console.log(result)
                this.log('Copied contact: ' + result.object.firstName)

                let sourceContactTransactionsRef = this.sourceTenantRef.child('contactTransactions').child(contactKey)
                let destContactTransactionsRef = DataHelpers.getRootRef().child('tenants').child(tenant).child('contactTransactions')
                
                this.copyFirebaseData(sourceContactTransactionsRef, destContactTransactionsRef, this.move, true).then(tcResult => {
                    console.log('TC Result', tcResult)
                    let transactionArray = Object.keys(tcResult.object)
                    this.log('Copied ' + transactionArray.length + ' contact-transactions')
                    transactionArray.forEach(transactionKey => {
                        let sourceTransactionRef = this.sourceTenantRef.child('transactions').child(transactionKey)
                        let destTransactionRef = DataHelpers.getRootRef().child('tenants').child(tenant).child('transactions')
                        
                        this.copyFirebaseData(sourceTransactionRef, destTransactionRef, this.move, true).then(tResult => {
                            this.log('Copied transaction: ' + tResult.object.details.description)
                        })
                    })
                }, err => {
                    this.log(err.result + ' in contactTransactions')
                })
            })
        },

        createNewOffice() {
            this.log('Creating new office...')

            //Invites...

            let ref = DataHelpers.getRootRef().child('invites').child(this.newOfficeNumber)
            ref.update({
                name: this.newOfficeName,
                read: this.newOfficePin, 
                write: this.newOfficePin
            })
            this.log('Invites Done.')

            //Current User....

            ref = DataHelpers.getRootRef().child('users').child(DataHelpers.getUserId()).child('offices').child(this.newOfficeNumber)
            ref.update({
                name: this.newOfficeName,
                read: true,
                write: true,
            })
            this.log('Current user Granted Permission.')

        },

        copyFirebaseData(fromRef, toRef, move = false, keepSameKey = false) {
        
            return new Promise( (resolve, reject) => {
                console.log('Preparing copyFirebaseData from: ' + fromRef.toString() + ' to ' + toRef.toString())
                let result = {}
                fromRef.once('value', snap => {
                    let obj = snap.val()
                    
                    if(!obj) {
                        result.result = 'Data not found'
                        reject(result)
                    }
                    let newKey = (keepSameKey ? snap.key : DataHelpers.getKey() )

                    if(!this.simulateWrites)
                        toRef.child(newKey).set(obj)
                    else
                        this.log('Simulating write only...')

                    if(move) {
                        this.deleteFirebaseData(fromRef)

                    }

                    result.sourceRef = fromRef.toString()
                    result.destinationRef = toRef.toString()
                    result.object = obj
                    result.sourceKey = snap.key
                    result.destinationKey = newKey
                    resolve(result)
                })
            })
        },

        deleteFirebaseData(fromRef) {
            this.log('Deleting ' + fromRef.toString())
            if(this.simulateDeletes) {
                this.log('Simulating delete only')
                return
            }
            fromRef.remove()
        }



    },

    created() {
        this.initialiseDialog()
    }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


// WEBPACK FOOTER //
// Maintenance.vue?9446a2fc